export enum PolicyInitiativeEditorialStatus {
  Draft = 'Draft',
  Pending = 'Pending',
  Published = 'Published',
  Rejected = 'Rejected'
}
